<div class="full-screen-viewer-content">
  <div class="left-panel flex-none overflow-y-auto">
    <ng-content select="[left-panel]"> </ng-content>
  </div>

  <oui-document-viewer [documentUrl]="documentUrl" [showControls]="true">
    @if (!isMissingFile && !documentUrl) {
      <oui-loading></oui-loading>
    }

    @if (isMissingFile) {
      <oui-etat-vide icon="unknown_document" [title]="missingFileTitle"></oui-etat-vide>
    }

    <ng-container oui-document-controls>
      <ng-content select="[right-panel]"></ng-content>
    </ng-container>
  </oui-document-viewer>
</div>
@if (withFooter) {
  <div class="full-screen-viewer-footer">
    <oui-button type="text" class="flex-none" (click)="cancel()">
      {{ cancelButtonLabel }}
    </oui-button>
    <oui-button type="contained" class="flex-none" (click)="validate()" [disabled]="isValidateDisabled">
      {{ validateButtonLabel }}
    </oui-button>
    @if (optionnalButton1Label) {
      <oui-button
        type="contained"
        [color]="optionnalButtonColor"
        class="flex-none"
        (click)="optionnalButton1Click()"
        [disabled]="isOptionnalButton1Disabled">
        {{ optionnalButton1Label }}
      </oui-button>
    }
  </div>
}
